var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43345 6.88576C5.08223 6.32492 5.1479 6.16755 5.1479 6.16755L6.19299 4.64813C6.47282 4.27042 6.43284 3.74392 6.10161 3.41199L3.93721 1.25734C3.62311 0.942585 3.12341 0.913971 2.7722 1.18581L1.83276 1.91547C1.75281 1.97842 1.67857 2.04996 1.61861 2.13294C-0.234558 4.72539 2.36673 8.80864 5.57336 12.0049C8.69148 15.1124 12.9146 17.8822 15.4645 15.9021C15.5359 15.8449 15.5987 15.7791 15.6558 15.7047L16.3897 14.7432C16.6609 14.3884 16.6267 13.8905 16.3097 13.5758L14.1482 11.4211C13.8141 11.0892 13.2887 11.052 12.9146 11.3353L11.4041 12.3911C11.4041 12.3911 10.8016 12.6115 7.86912 9.68996C6.82118 8.64554 6.17585 7.90157 5.77895 7.3722C5.63618 7.18335 5.52482 7.02025 5.43916 6.8829",
    stroke: "#6856DB",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.0bbd1dc56ab48c813a1125e995913c5c.svg";
export { ForwardRef as ReactComponent };